import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'gcc-urgent-alerts-slider',
  templateUrl: './urgent-alerts-slider.component.html',
  styleUrls: ['./urgent-alerts-slider.component.scss']
})
export class UrgentAlertsSliderComponent {
  @Input() public sliderData: any[] = [];

  @Output() public delete = new EventEmitter<string>();

  public currentSlide = 0;

  get isFirstStepDisabled(): boolean {
    return this.currentSlide === 0;
  }
  get isSecondStepDisabled(): boolean {
    return this.currentSlide === this.sliderData.length - 1;
  }

  public onPreviousClick() {
    if (!this.isFirstStepDisabled) {
      const previous = this.currentSlide - 1;
      this.currentSlide = previous < 0 ? this.sliderData.length - 1 : previous;
    }
  }

  public onNextClick() {
    const next = this.currentSlide + 1;
    this.currentSlide = next === this.sliderData.length ? 0 : next;
  }

  public handleDelete(id: string): void {
    this.delete.emit(id);
    this.onPreviousClick();
  }
}
